import {Dispatch, SetStateAction, useEffect, useState} from "react";

export default function useFilters<T = object | {}>(props?: {
    filters?: T,
    setFilters?: Dispatch<SetStateAction<T>>,
}): [T, Dispatch<SetStateAction<T>>] {
    const [filters, setFilters] = useState<T>({} as T)

    useEffect(() => {
        if (props?.filters != null) {
            setFilters(props.filters)
        }
    }, [props?.filters]);

    useEffect(() => {
        if (props?.setFilters != null) {
            props.setFilters({...props.filters, ...filters} as T)
        }
    }, [filters]);

    return [filters, setFilters]
}